import { CreateEditTruckRouteEnum } from 'Common/FieldEnum';
import * as types from './types';

const INITIAL_STATE = {
  siteItems: [],
  siteItemsMessage: null,
  siteItemsLoading: false,
  siteItemsLoadingError: null,
  initialSelectedSites: [],
  initialSelectedVendors: [],
  saving: false,
  saveError: null,
  saved: null,
  selectedTruckRouteDetailLoading: false,
  selectedTruckRouteDetail: null,
  selectedTruckRouteDetailError: null,
  vendorItemsLoading: false,
  vendorItemsLoadingError: null,
  truckRouteAssignmentTypes: [],
  truckRouteAssignmentTypesLoading: false,
  truckRouteAssignmentTypesLoadingError: null,
  truckRouteTypesLoading: false,
  truckRouteTypes: [],
  truckRouteTypesLoadingError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_SITE_ITEMS_BY_SITE_IDS:
      return { ...state, siteItems: action.payload };
    case types.GET_SITE_ITEMS_BY_SITE_IDS_LOADING:
      return { ...state, siteItemsLoading: action.payload };
    case types.GET_SITE_ITEMS_BY_SITE_IDS_LOADING_ERROR:
      return { ...state, siteItemsLoadingError: action.payload };
    case types.SET_SELECTED_SITES:
      const initialSelectedSites = [...state.initialSelectedSites];
      initialSelectedSites.push(action.payload);
      return { ...state, initialSelectedSites };
    case types.SAVE_TRUCK_ROUTE_LOADING:
      return { ...state, saving: action.payload };
    case types.SAVE_TRUCK_ROUTE_LOADING_ERROR:
      return { ...state, saveError: action.payload };
    case types.SAVE_TRUCK_ROUTE:
      return { ...state, saved: action.payload };
    case types.CLEAR_SAVE_TRUCK_ROUTE:
      return { ...state, saved: null };
    case types.CLEAR_SITE_ITEMS:
      return { ...state, siteItems: [] };
    case types.CLEAR_ERRORS:
      return {
        ...state,
        siteItemsLoadingError: null,
        saveError: null,
        selectedTruckRouteDetailError: null,
        vendorItemsLoadingError: null,
        truckRouteAssignmentTypesLoadingError: null,
        truckRouteTypesLoadingError: null,
      };
    case types.SELECTED_TRUCK_ROUTE_DETAIL_LOADING:
      return { ...state, selectedTruckRouteDetailLoading: action.payload };
    case types.SELECTED_TRUCK_ROUTE_DETAIL:
      return {
        ...state,
        selectedTruckRouteDetail: action.payload,
        initialSelectedSites: action.payload[CreateEditTruckRouteEnum.SiteIds],
        initialSelectedVendors:
          action.payload[CreateEditTruckRouteEnum.VendorIds],
      };
    case types.SELECTED_TRUCK_ROUTE_DETAIL_LOADING_ERROR:
      return { ...state, selectedTruckRouteDetailError: action.payload };
    case types.SET_SITE_ITEMS_MESSAGE:
      return { ...state, siteItemsMessage: action.payload };
    case types.CLEAR_SITE_ITEMS_MESSAGE:
      return { ...state, siteItemsMessage: null };
    case types.GET_ITEMS_BY_VENDOR_IDS:
      return { ...state, siteItems: action.payload };
    case types.GET_ITEMS_BY_VENDOR_IDS_LOADING:
      return { ...state, vendorItemsLoading: action.payload };
    case types.GET_ITEMS_BY_VENDOR_IDS_LOADING_ERRORS:
      return { ...state, vendorItemsLoadingError: action.payload };
    case types.GET_TRUCK_ROUTE_ASSIGNMENT_TYPES:
      return { ...state, truckRouteAssignmentTypes: action.payload };
    case types.GET_TRUCK_ROUTE_ASSIGNMENT_TYPES_LOADING:
      return { ...state, truckRouteAssignmentTypesLoading: action.payload };
    case types.GET_TRUCK_ROUTE_ASSIGNMENT_TYPES_LOADING_ERROR:
      return {
        ...state,
        truckRouteAssignmentTypesLoadingError: action.payload,
      };
    case types.GET_TRUCK_ROUTE_TYPES_LOADING:
      return { ...state, truckRouteTypesLoading: action.payload };
    case types.GET_TRUCK_ROUTE_TYPES:
      return { ...state, truckRouteTypes: action.payload };
    case types.GET_TRUCK_ROUTE_TYPES_LOADING_ERROR:
      return { ...state, truckRouteTypesLoadingError: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/createedittruckroute/reducer.js